import { render } from "./Resulf.vue?vue&type=template&id=3e8e2982&scoped=true"
import script from "./Resulf.vue?vue&type=script&lang=js"
export * from "./Resulf.vue?vue&type=script&lang=js"

import "./Resulf.vue?vue&type=style&index=0&id=3e8e2982&scoped=true&lang=css"

import exportComponent from "E:\\work\\copy\\work\\fa\\tgkw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e8e2982"]])

export default __exports__